export const meta: BlockMeta = {
  title: "Related Projects",
  tags: ["#page"],
}

import { Button } from "@components/atoms/Button"
import { ProjectTile } from "@components/content/ProjectTile"
import { defineBlock, EditableText } from "eddev/blocks"

export default defineBlock("content/related-projects", (props) => {
  const projects =
    props.project?.projectHeader?.location
      ?.flatMap((location) => location?.contentNodes?.nodes)
      .flat()
      .filter(Boolean) || []

  if (projects.length < 2) {
    projects.push(...(props.allProjects?.nodes ?? []))
  }

  if (projects.length === 0) {
    return null
  }

  return (
    <div className="content-sized block-spacing relative flex flex-col gap-6">
      <div className="w-full flex items-center justify-between gap-3 pb-7">
        <EditableText
          as="h3"
          store="title"
          className="type-desktop-headings-heading-s"
          placeholder="Related Projects"
          defaultValue="Related Projects"
        />
        <Button href="/projects" outerClassName="mt-[0.2em]">
          <EditableText as="span" store="buttonText" placeholder="All Projects" defaultValue="All Projects" />
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {projects
          ?.slice(0, 2)
          .filter((project) => !!project && "uri" in project)
          .map((project, index) => (
            <ProjectTile key={project.id} project={project} />
          ))}
      </div>
    </div>
  )
})
